import React, { useState, useEffect } from "react";
import Layout from "../../components/Wrappers/Layout";
import BackButton from "../../components/BackButton/BackButton";
import { NavLink } from "react-router-dom";
import { Card, Alert } from "reactstrap";
import { AiOutlineSearch } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@mui/styles";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import SearchIcon from "@mui/icons-material/Search";
import EditIcon from "@mui/icons-material/Edit";
// import Tooltip from "@mui/material/Tooltip";
import { Tooltip } from "antd";
import { dealerAddUpdateDsrLimits } from "../../redux/actions/dealerAddUpdateDsrLimitsAction";
import SOLogout from "../../components/Logout/SOLogout";
import Util from "../../validation/index";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Checkbox,
	FormControlLabel
} from "@mui/material";
import moment from "moment";
import { FormControl } from "@mui/material";
import { useHistory, useNavigate } from "react-router-dom";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import { dealerSetDsrLimits } from "../../redux/actions/dealerSetDsrLimitsAction";

const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});
const DealerAddLimit = () => {
	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [isLoading, setIsLoading] = useState(true);
	const [setDsrLimitsListStatus, setSetDsrLimitsListStatus] = useState(false);
	const [setDsrLimitsListArray, setSetDsrLimitsListArray] = useState([]);
	const [updatedWithdrawLimitStatus, setUpdatedWithdrawLimitStatus] =
		useState(false);
	const [updateWithdrawLimitPopup, setUpdateWithdrawLimitPopup] = useState("");

	const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;
	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	const updateWithdrawLimitRes = useSelector(
		({ dealerAddUpdateDsrLimits }) => dealerAddUpdateDsrLimits
	);
	var authToken = regenerateTokenRes.data.AuthToken;
	//update information
	const [limitId, setLimitId] = useState("");
	const [open, setOpen] = React.useState(false);
	const [updateLoadLimit, setUpdateLoadLimit] = useState(false);
	const [getDsrNumber, setGetDsrNumber] = useState("");
	const [getDsrId, setGetDsrId] = useState("");
	const [editCurrency, setEditCurrency] = useState("");
	const [editDailyAmountLimit, setEditDailyAmountLimit] = useState("");
	const [editWeeklyAmountLimit, setEditWeeklyAmountLimit] = useState("");
	const [editMonthlyAmountLimit, setEditMonthlyAmountLimit] = useState("");
	const [editYearlyAmountLimit, setEditYearlyAmountLimit] = useState("");
	const [updateLoadLimitResArray, setUpdateLoadLimitResArray] = useState("");
	const [notificationOpen, setNotificationOpen] = React.useState(false);

	const edit = "edit";
	const [editOpen, setEditOpen] = React.useState(false);

	// const [userUpdateData, setUserUpdateData] = useState(
	//     {
	//         userDsr: "",
	//         currency: "",
	//         dsrID: "",
	//         dailyAmountLimit: "",
	//         weeklyAmountLimit: "",
	//         monthlyAmountLimit: "",
	//         yearlyAmountLimit: "",
	//         limitId: ""
	//     }
	// );
	// const {
	//     userDsr,
	//     currency,
	//     dsrID,
	//     dailyAmountLimit,
	//     weeklyAmountLimit,
	//     monthlyAmountLimit,
	//     yearlyAmountLimit,
	//     limitId
	// } = userUpdateData;

	const [user, setUser] = useState({
		dsrId: "",
		dsrNumber: ""
	});

	// const setData = (row, fs) => {
	//     if (fs == "edit") {
	//         setEditOpen(true);
	//     }
	//     setUserUpdateData({
	//         userDsr: row.dsrNumber,
	//         dsrID: row.dsrId,
	//         currency: row.currency,
	//         dailyAmountLimit: row.daily,
	//         weeklyAmountLimit: row.weekly,
	//         monthlyAmountLimit: row.monthly,
	//         yearlyAmountLimit: row.yearly,
	//         limitId: row.limitId

	//     })
	// }
	// const handleClose = () => {
	//     setEditOpen(false);
	//     setUserUpdateData({
	//         userDsr: "",
	//         dsrID: "",
	//         currency: "",
	//         dailyAmountLimit: "",
	//         weeklyAmountLimit: "",
	//         monthlyAmountLimit: "",
	//         yearlyAmountLimit: "",
	//         limitId: ""
	//     })
	// }
	const { dsrId, dsrNumber } = user;
	const handleClose = () => {
		setOpen(false);
	};

	const onInputChange = ({ target: { name, value } }, type) => {
		// setUser({ ...user, [e.target.name]: e.target.value });
		const obj = {
			...user
			// ...userUpdateData
		};

		if (type == "number") {
			obj[name] = Util.verifyMobile(value) ? value : obj[name];
		} else if (type == "alphabet") {
			obj[name] = Util.verifyAlphabet(value) ? value : obj[name];
		} else if (type == "both") {
			obj[name] = Util.alphaNumeric(value) ? value : obj[name];
		} else {
			// obj[name] = value.trim()
			obj[name] = Util.noWhiteSpace(value) ? value : obj[name];
		}
		setUser(obj);
		// setUserUpdateData(obj)
	};
	const handleChange = ({ target: { name, value } }) => {
		if (name === "GetDsrId") {
			setGetDsrId(value == "Select Dsr" ? "" : value);
			// setLevel(value);
		}
		if (name === "GetDsrNumber") {
			setGetDsrNumber(value);
		}

		if (name === "EditCurrency") {
			setEditCurrency(value);
		}

		if (name === "EditDailyAmountLimit") {
			//  setEditDailyAmountLimit(value);
			Util.verifyAmount(value)
				? setEditDailyAmountLimit(value)
				: setEditDailyAmountLimit(editDailyAmountLimit);
		}

		if (name === "EditWeeklyAmountLimit") {
			// setEditWeeklyAmountLimit(value);
			Util.verifyAmount(value)
				? setEditWeeklyAmountLimit(value)
				: setEditWeeklyAmountLimit(editWeeklyAmountLimit);
		}

		if (name === "EditMonthlyAmountLimit") {
			//      setEditMonthlyAmountLimit(value);
			Util.verifyAmount(value)
				? setEditMonthlyAmountLimit(value)
				: setEditMonthlyAmountLimit(editMonthlyAmountLimit);
		}

		if (name === "EditYearlyAmountLimit") {
			//  setEditYearlyAmountLimit(value);
			Util.verifyAmount(value)
				? setEditYearlyAmountLimit(value)
				: setEditYearlyAmountLimit(editYearlyAmountLimit);
		}
	};
	// const onInputChangeEdit = ({ target: { name, value } }, type) => {
	//     // setUser({ ...user, [e.target.name]: e.target.value });
	//     const obj = {
	//         ...userUpdateData
	//     };

	//     if (type == "number") {
	//         obj[name] = Util.verifyMobile(value) ? value : obj[name];
	//     } else if (type == "alphabet") {
	//         obj[name] = Util.verifyAlphabet(value) ? value : obj[name];
	//     } else if (type == "both") {
	//         obj[name] = Util.alphaNumeric(value) ? value : obj[name];
	//     } else {
	//         // obj[name] = value.trim()
	//         obj[name] = Util.noWhiteSpace(value) ? value : obj[name];
	//     }

	//     setUserUpdateData(obj)
	// };
	const editLoadLimit = (
		limitId,
		dsrId,
		currency,
		// level,
		daily,
		weekly,
		monthly,
		yearly,
		dsrNumber
	) => {
		setLimitId(limitId);
		setEditCurrency(currency);
		setGetDsrId(dsrId);
		setGetDsrNumber(dsrNumber);
		setEditDailyAmountLimit(daily);
		setEditWeeklyAmountLimit(weekly);
		setEditMonthlyAmountLimit(monthly);
		setEditYearlyAmountLimit(yearly);
		setOpen(true);
	};
	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};
	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};
	const setDsrLimitsList = useSelector(
		({ dealerSetDsrLimits }) => dealerSetDsrLimits
	);
	const classes = useStyles();
	const dispatch = useDispatch();
	const handleNoticationClose = () => {
		setNotificationOpen(false);
	};
	const setDsrLimitsListReq = () => {
		setSetDsrLimitsListStatus(true);
		setIsLoading(true);
		const req = {
			actionCustomerMasterRequestVO: {
				dealerId: regenerateTokenRes.data.partnerId || "",
				dsrNumber: dsrNumber,
				// dsrName: userName,
				dsrId: dsrId
			}
		};
		dispatch(dealerSetDsrLimits(req, authToken));
	};

	const setDsrLimitsListFunc = () => {
		if (setDsrLimitsListStatus) {
			if (setDsrLimitsList.data.status == "success") {
				setSetDsrLimitsListArray([].concat(setDsrLimitsList.data.dsrList));
			}
			if (setDsrLimitsList.data.status == "failed") {
				setSetDsrLimitsListArray(setDsrLimitsList.data);
				if (
					setDsrLimitsList.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					setDsrLimitsList.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			setIsLoading(false);
		}
	};
	const updateLoadLimitFunc = () => {
		// setIsLoading(true);

		// setLimitId(limitId);
		setUpdatedWithdrawLimitStatus(true);

		setOpen(false);

		const req = {
			actionCustomerMasterRequestVO: {
				dealerId: regenerateTokenRes.data.partnerId || "",
				dsrId: getDsrId,
				dsrNumber: getDsrNumber,
				// dsrNumber: userDsr,
				currency: editCurrency,
				dailyLimit: editDailyAmountLimit,
				weeklyLimit: editWeeklyAmountLimit,
				monthlyLimit: editMonthlyAmountLimit,
				yearlyLimit: editYearlyAmountLimit,
				limitId: limitId
			}
		};
		dispatch(dealerAddUpdateDsrLimits(req, authToken));
	};

	const updateUserWithDrawLimit = () => {
		if (updatedWithdrawLimitStatus) {
			if (updateWithdrawLimitRes.data.status == "success") {
				// setIsLoading(true);
				setDsrLimitsListReq();

				setOpen(false);
				setUpdateWithdrawLimitPopup(updateWithdrawLimitRes.data);
				setNotificationOpen(true);
			}
			if (updateWithdrawLimitRes.data.status == "failed") {
				// setIsLoading(true);

				setOpen(false);
				setUpdateWithdrawLimitPopup(updateWithdrawLimitRes.data);
				// setNotificationOpen(true);
				if (
					updateWithdrawLimitRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					updateWithdrawLimitRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (updateWithdrawLimitRes.data.status == "Failed") {
				// setIsLoading(true);

				setOpen(false);
				setUpdateWithdrawLimitPopup(updateWithdrawLimitRes.data);
				setNotificationOpen(true);
				if (
					updateWithdrawLimitRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					updateWithdrawLimitRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};
	useEffect(() => {
		updateUserWithDrawLimit();
	}, [updateWithdrawLimitRes.data.status]);

	// const updateWithdrawLimitFunc = () => {
	//     setEditOpen(false)
	//     setUpdatedWithdrawLimitStatus(true);
	//     const req = {
	//         actionCustomerMasterRequestVO: {
	//             dealerId: partnerloginUser.data.partnerId,
	//             dsrId: dsrId,
	//             dsrNumber: userDsr,
	//             currency: currency,
	//             dailyLimit: dailyAmountLimit,
	//             weeklyLimit: weeklyAmountLimit,
	//             monthlyLimit: monthlyAmountLimit,
	//             yearlyLimit: yearlyAmountLimit

	//         }
	//     }
	//     dispatch(dealerAddUpdateDsrLimits(req, authToken))
	// }
	useEffect(() => {
		setDsrLimitsListFunc();
	}, [setDsrLimitsList.data.status]);

	// useEffect(() => {
	//     // getRoleListReq();
	//     setDsrLimitsListReq()
	// }, []);

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			setDsrLimitsListReq();
		}
	}, [regenerateTokenRes.data.status]);
	return (
		<>
			<Layout>
				<BackButton />
				<Card>
					<Grid container style={{ padding: "25px", justifyContent: "right" }}>
						{/* <Grid item md={7} sm={12} lg={5}></Grid> */}
						<Grid item md={3} sm={12} xs={12} lg={3}>
							<NavLink to="/index/DealerAddNewDsrLimit">
								{/* <Button
                                    variant="contained"
                                    style={{ backgroundColor: "#00b9f5", color: "white" }}
                                    size="small"
                                >
                                    Add New DSR Limit
                                </Button> */}

								<CustomButton
									style={{
										padding: "8px",
										margin: "0 8px"
									}}
								>
									Add New DSR Limit
								</CustomButton>
							</NavLink>
						</Grid>
						<Grid item md={3} sm={12} xs={12} lg={3}>
							<NavLink to="/index/DealerUploadDsrLimit">
								{/* <Button
                                    variant="contained"
                                    style={{ backgroundColor: "#00b9f5", color: "white" }}
                                    size="small"
                                >
                                    Upload DSR Limit
                                </Button> */}
								<CustomButton
									style={{
										padding: "8px",
										margin: "0 8px"
									}}
								>
									Upload DSR Limit
								</CustomButton>
							</NavLink>
						</Grid>
					</Grid>

					<Grid
						container
						spacing={2}
						style={{ padding: "25px", marginTop: "2rem" }}
					>
						<Grid item xs={12} sm={6} md={4} lg={3}>
							<TextField
								size="small"
								color="primary"
								type="text"
								label="DSR ID"
								fullWidth={true}
								name="dsrId"
								value={dsrId}
								// onChange={onInputChange}
								onChange={(e) => onInputChange(e, "number")}
							></TextField>
						</Grid>
						<Grid item xs={12} sm={6} md={4} lg={3}>
							<TextField
								size="small"
								color="primary"
								type="text"
								label="DSR Number"
								fullWidth={true}
								name="dsrNumber"
								value={dsrNumber}
								// onChange={onInputChange}
								onChange={(e) => onInputChange(e, "number")}
							></TextField>
						</Grid>

						<Grid item xs={12} sm={6} md={4} lg={3}>
							``
							{/* <Button
                                style={{
                                    backgroundColor: "#00b9f5",
                                    color: "white",
                                    marginTop: "9px",
                                }}
                                endIcon={<AiOutlineSearch />}
                                variant="contained"
                            // onClick={}
                            >
                                Search
                            </Button> */}
							<CustomButton
								style={{
									padding: "8px",
									margin: "0 8px"
								}}
								variant="contained"
								onClick={setDsrLimitsListReq}
							>
								Search
								<SearchIcon style={{ marginLeft: "4px", fontSize: "21px" }} />
							</CustomButton>
						</Grid>
					</Grid>
				</Card>
				{isLoading ? (
					<LoadingSpinner />
				) : setDsrLimitsListArray.length == undefined ||
					!setDsrLimitsListStatus ? (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography variant="body1" style={{ fontWeight: "700" }}>
									Report Table
								</Typography>
							</Grid>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Alert
									className="my-3 themeBackground"
									variant="secondary"
									style={{ color: "white" }}
								>
									No Records Found!
								</Alert>
							</Grid>
						</Grid>
					</Card>
				) : (
					<div>
						<Card>
							<Grid
								container
								style={{
									padding: "10px"
								}}
							>
								<Grid xs={12} sm={12} md={12} lg={12}>
									<Typography variant="body1" style={{ fontWeight: "700" }}>
										Report Table
									</Typography>
								</Grid>
								<TableContainer component={Paper} className="text-nowrap my-3 ">
									<Table className={classes.table}>
										<TableHead>
											<TableRow
												style={{ background: "#00b9f5" }}
												className="themeBackground"
											>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Dsr Id
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Dsr Mob No.
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Currency
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Daily Amount Limit
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Weekly Amount Limit
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Monthly Amount Limit
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Yearly Amount Limit
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Id Number
												</TableCell>

												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Action
												</TableCell>
											</TableRow>
										</TableHead>

										<TableBody>
											{setDsrLimitsListArray &&
												[]
													.concat(setDsrLimitsListArray)
													.slice(
														page * rowsPerPage,
														page * rowsPerPage + rowsPerPage
													)
													.map((row, index) => (
														<TableRow>
															<TableCell align="center">{row.dsrId}</TableCell>
															<TableCell align="center">
																{row.dsrNumber}
															</TableCell>
															<TableCell align="center">
																{row.currency}
															</TableCell>
															<TableCell align="center">{row.daily}</TableCell>
															<TableCell align="center">{row.weekly}</TableCell>

															<TableCell align="center">
																{row.monthly}
															</TableCell>
															<TableCell align="center">{row.yearly}</TableCell>
															<TableCell align="center">
																{row.idNumber}
															</TableCell>

															<TableCell align="center">
																<Tooltip title="Edit">
																	<CustomButton
																		style={{
																			padding: "8px"
																		}}
																		onClick={() =>
																			editLoadLimit(
																				row.idNumber,

																				row.dsrId,
																				row.currency,

																				row.daily,
																				row.weekly,
																				row.monthly,
																				row.yearly
																			)
																		}
																	// onClick={() => setData(row, edit)}
																	// onClick={() =>
																	//     editWithdrawLimit(
																	//         row.limitId,
																	//         row.customerName,
																	//         row.level,
																	//         row.daily,
																	//         row.weekly,
																	//         row.monthly,
																	//         row.yearly
																	//     )
																	// }
																	>
																		Update
																		{/* {
                                                                            <EditIcon
                                                                                style={{
                                                                                    color: "#fff",
                                                                                    fontSize: "20px",
                                                                                }}
                                                                            />
                                                                        } */}
																	</CustomButton>
																</Tooltip>
															</TableCell>
														</TableRow>
													))}
										</TableBody>
									</Table>
									<TablePagination
										rowsPerPageOptions={[5, 10, 25]}
										component="div"
										count={[].concat(setDsrLimitsListArray).length}
										rowsPerPage={rowsPerPage}
										page={page}
										onChangePage={handleChangePage}
										onChangeRowsPerPage={handleChangeRowsPerPage}
									/>
								</TableContainer>
							</Grid>
						</Card>
					</div>
				)}
				<div>
					<Dialog open={open} onClose={handleClose}>
						<DialogTitle>Update Load Limit</DialogTitle>
						<DialogContent>
							<TextField
								style={{ marginTop: "10px" }}
								// select
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Dsr"
								fullWidth={true}
								name="GetDsrId"
								value={getDsrId || ""}
								onChange={handleChange}
								disabled
							>
								{/* {adminCurrencyList.success &&
                                    adminCurrencyList.data.currencyList.map((x) => (
                                        <MenuItem value={x}>{x}</MenuItem>
                                    ))} */}
							</TextField>
							<TextField
								style={{ marginTop: "10px" }}
								// select
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Currency"
								fullWidth={true}
								name="EditCurrency"
								value={editCurrency || ""}
								onChange={handleChange}
								disabled
							>
								{/* {adminCurrencyList.success &&
                                    adminCurrencyList.data.currencyList.map((x) => (
                                        <MenuItem value={x}>{x}</MenuItem>
                                    ))} */}
							</TextField>

							<TextField
								required
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Daily Amount Limit"
								value={editDailyAmountLimit || ""}
								name="EditDailyAmountLimit"
								fullWidth={true}
								onChange={handleChange}
							></TextField>
							<TextField
								required
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Weekly Amount Limit"
								value={editWeeklyAmountLimit || ""}
								name="EditWeeklyAmountLimit"
								fullWidth={true}
								onChange={handleChange}
							></TextField>
							<TextField
								required
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Monthly Amount Limit"
								value={editMonthlyAmountLimit || ""}
								name="EditMonthlyAmountLimit"
								fullWidth={true}
								onChange={handleChange}
							></TextField>
							<TextField
								required
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Yearly Amount Limit"
								value={editYearlyAmountLimit || ""}
								name="EditYearlyAmountLimit"
								fullWidth={true}
								onChange={handleChange}
							></TextField>
						</DialogContent>
						<DialogActions>
							<CustomButton
								style={{
									// backgroundColor: "#fff",
									color: "white"
								}}
								variant="contained"
								onClick={handleClose}
							>
								Cancel
							</CustomButton>
							<CustomButton
								style={{
									// backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={updateLoadLimitFunc}
							>
								Save
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			</Layout>
			{updateWithdrawLimitPopup.status == "success" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{updateWithdrawLimitPopup.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}
			{updateWithdrawLimitPopup.status == "failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{updateWithdrawLimitPopup.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}
			{updateWithdrawLimitPopup.status == "Failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{updateWithdrawLimitPopup.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}
		</>
	);
};

export default DealerAddLimit;
